import { createApp } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import App from './App.vue';
import { store } from './store';
import router from './router';

const app = createApp(App);

app.use(store);
app.use(Notifications);
app.use(router);

store.dispatch('initialize').then(() => {
    app.mount('#app');
}).catch(err => {
    console.error('Failed to initialize store:', err);
    app.mount('#app');
});